import React, { Component, useState } from 'react';
import AddressesMapView from './AddressesMapView';
import Geocode from "react-geocode";
import {portal_config} from '../../../portal.config'
import crmservices from '../../wsclient/crmservices';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';

function AddressesMap(props) {
    const [currentLocation, setCurrentLocation] = useState(null);
    const [add_info, setAddInfo] = useState({
        town_city: "",
        postal_code: "",
        country_code: "CY",
        lon: "",
        lat: "",
        address_line_1:"",
        googlePlaceId:"",
        state_province_county:"",
    });
    const [isHasAddress, setIsHasAddress] = useState(true);
    const [listAddressLookUp, setListAddressLookUp] = useState([]);
    const [showLoadingAddress, onShowLoadingAddress] = useState(false);
    const [showListAddress, onShowListAddress] = useState(false);
    const [addressText, setAddressText] = useState(null);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });

    const onAddressLookup = async(address) =>{
        onShowLoadingAddress(true);
        var addresses = [];
        try {
            var result = await crmservices.contacts.findAddress({ address: address });
            //console.log('onAddressLookup result=', result)
            if (result.code == 'OK') {
                addresses = result.data.content ? result.data.content : [];
            }
        } catch (error) {
            console.log("addresses lookup exception:", error);
        }
        onShowLoadingAddress(false);
        setListAddressLookUp(addresses);
    }
    const onSelectAddress = (address) =>{
        var location = {
            lat: address.lat,
            lon: address.lon
        }
        onShowLoadingAddress(false);
        setAddInfo(address);
        setCurrentLocation(location);
        setAddressText(address.address);
    }
    const onSelectLocation = (e) =>{
        //console.log('onSelectLocation e=',e);
         var location = {}
        location.lat = e.lat;
        location.lng = e.lng;
        setAddressName(location.lat, location.lng);
        //this.setState({ currentLocation: location }) 
    }
    const setAddressName = async(latitude, longitude) =>{
        //console.log("setAddressName addr latitude:", latitude);
        //console.log("setAddressName addr longitude:", longitude);
        var json = await Geocode.fromLatLng(latitude, longitude, portal_config.apiKey, "en");
        var result = json.results[0];
        //console.log("resssssssssssssss :", result);
        setAddressText(result.formatted_address);
        setIsHasAddress(true);
        setAddressInfo(result, latitude, longitude);
    }
    const setAddressInfo = (detail, latitude, longitude) =>{
        try {
            var address_component = detail.address_components;
            var formatted_address = detail.formatted_address;
            var addressInfor = clearAddInfor();
            //console.log("setAddressInfo :", addressInfor);
            if (address_component && address_component.length > 0) {
                address_component.forEach(element => {
                    if (element.types.length > 0) {
                        //console.log("element.long_name;:", element.long_name);
                        if (element.types[0] === 'country') {
                            addressInfor.country_code = element.short_name;
                        } else if (element.types[0] === 'postal_code') {
                            addressInfor.postal_code = element.long_name;
                        } else if (element.types[0] === 'locality') {
                            addressInfor.state_province_county = element.long_name;
                        }else if (element.types[0] === 'administrative_area_level_1') {
                            addressInfor.town_city = element.long_name;
                        }
                    }
                });
            }
            if (latitude)
                addressInfor.lat = latitude;
            if (longitude)
                addressInfor.lon = longitude;
            if(formatted_address){
                addressInfor.address_line_1 = formatted_address;
            }

            if(detail.place_id){
                //addressInfor.googlePlaceId = detail.place_id;
                addressInfor.googlePlaceid = detail.place_id;
            }
            console.log("setAddressInfo :", addressInfor);
            setAddInfo(addressInfor);
        } catch (error) {
            console.log("set address info exception:", error);
        }
    }
    const onCreateNewAddress = () =>{
        //console.log('add_info===', add_info)
        if (!add_info.googlePlaceId && !add_info.address_line_1 && !add_info.postal_code && !add_info.state_province_county && !add_info.town_city && !add_info.lat && !add_info.lon) {
            showAlert(t('SUCCESS'), t('please_select_address'));
        } else {
            if(add_info.address){
                setAddInfo(prevState=>({
                    ...prevState,
                    address_line_1: add_info.address
                }))
            }
        //console.log('add_info========',add_info)
        props.onClose(add_info);
        }
    }
    const clearAddInfor = () =>{// phần này có 2 chỗ cần chinhr ở app thì mới update đuợc
        var addressInfor = {
            town_city: "",
            postal_code: "",
            //district: "",
            country_code: "",
            address_line_1:"",
            //googlePlaceId:"",
            googlePlaceid:"",
            state_province_county:"",
            lat:"",
            lon:""
        }
        return addressInfor;
    }
    const onSearchPlace = (detail) =>{
        //console.log("onSearchPlace detail:",detail);
        var geometry = detail.geometry.location;
        this.setAddressInfo(detail, geometry.lat(), geometry.lng());
        var location = {
            lat: geometry.lat(),
            lon: geometry.lng(),
        }
        setCurrentLocation(location)
    }
    const showAlert = (status, message, title) =>{
        onShowLoadingAddress(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = () =>{
        onShowLoadingAddress(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        })
    }
    return (
        <div>
            <AddressesMapView
                open = {props.open}
                onClose = {props.onClose}
                onSelectLocation = {onSelectLocation}
                currentLocation = {currentLocation}
                onCreateNewAddress = {onCreateNewAddress}
                onSearchPlace = {onSearchPlace}
                addressText = {addressText}
                onHandleChangeSearch = {setAddressText}
                add_info={add_info}
                onAddressLookup={onAddressLookup}
                listAddressLookUp={listAddressLookUp}
                onSelectAddress={onSelectAddress}
                showLoadingAddress={showLoadingAddress}/>
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
        </div>
    );
}

export default AddressesMap;